import {resourceType, MODE} from '../../../constant'
const defaultViewKey = 'view'
const defaultFromKey = 'from'
/**
 * 为 self 附加属性 matchedComponents{array} 包含根据路由参数匹配到的当前页面应该渲染的 components
 *
 * 默认路由配置为：{ path: '/params/:view?' }
 * 如果嵌套资源 默认路由配置为：{ path: '/params/:view?/:from?' }
 * @param self
 * @param options
 */
export function matchedComponentsMixin (self, options) {
  let matchedView
  const viewKey = options.route && options.route.key ? options.route.key : defaultViewKey
  const routeViewParam = self.$route.params[viewKey]

  //默认主资源dialog模式
  !options.mode && (options.mode = MODE.EDIT_IN_DIALOG)

  if (!routeViewParam) {
    self.matchedComponents = ['list']
    return
  }

  // viewMap: 路由参数映射到一个具体的component （对于具体返回的components还要根据mode 和 resourceType具体决定）
  let viewMap = generateDefaultResourceViewMap(resourceType.MAIN, '', options.mode)

  if (options.route && options.route.map) {
    viewMap = mergeRouteMap(resourceType.MAIN, viewMap, options.route.map)
  }

  // 构建viewMap根据声明的嵌套资源和平行资源 补充defaultViewMap
  // 嵌套资源
  if (options.nestedResource && Array.isArray(options.nestedResource)) {
    for(let resource of options.nestedResource) {
      //默认嵌套资源in table模式
      !resource.mode && (resource.mode = MODE.EDIT_IN_TABLE)
      const name = resource.data.name
      let resourceViewMap = generateDefaultResourceViewMap(resourceType.NESTED, name, resource.mode)

      if (resource.route && resource.route.map) {
        resourceViewMap = mergeRouteMap(resourceType.NESTED, resourceViewMap, resource.route.map, name)
      }

      viewMap = Object.assign({}, viewMap, resourceViewMap)
    }
  }

  // 平行资源
  if (options.parallelResource && Array.isArray(options.parallelResource)) {
    for(let resource of options.parallelResource) {
      //默认平行资源资源dialog模式
      !resource.mode && (resource.mode = MODE.EDIT_IN_TABLE)
      const name = resource.data.name
      let resourceViewMap = generateDefaultResourceViewMap(resourceType.PARALLEL, name, resource.mode)

      if (resource.route && resource.route.map) {
        resourceViewMap = mergeRouteMap(resourceType.PARALLEL, resourceViewMap, resource.route.map, name)
      }

      viewMap = Object.assign({}, viewMap, resourceViewMap)
    }
  }

  matchedView = viewMap[routeViewParam]

  // 根据mode 和 资源种类 来决定渲染哪些组件
  // 如果没有匹配到 直接返回主资源list
  if (!matchedView) {
    self.matchedComponents = ['list']
    return
  }

  if (matchedView.type === resourceType.MAIN) {
    switch (matchedView.mode) {
      case MODE.EDIT_IN_DIALOG:
        self.matchedComponents = ['list', matchedView.name]
        return
      case MODE.EDIT_IN_NEW_PAGE:
        self.matchedComponents = [matchedView.name]
        return
      default:
        self.matchedComponents = ['list']
        return
    }
  }

  if (matchedView.type === resourceType.NESTED) {
    // 如果存在嵌套资源，父资源无法使用 EDIT_IN_TABLE
    if (options.mode === MODE.EDIT_IN_TABLE) {
      throw new Error('mode error: not support MODE:EDIT_IN_TABLE for parent resource while nested resource exist')
    }

    //子资源无法使用 EDIT_IN_NEW_PAGE（会失去页面状态）
    if (matchedView.mode === MODE.EDIT_IN_NEW_PAGE) {
      throw new Error('mode error: not support MODE:EDIT_IN_NEW_PAGE for nested resource')
    }

    //主、子资源不能同时为 EDIT_IN_DIALOG（不能嵌套弹窗）
    if (options.mode === MODE.EDIT_IN_DIALOG && matchedView.mode === MODE.EDIT_IN_DIALOG) {
      throw new Error(`mode error: parent and children resource can't be EDIT_IN_DIALOG at the same time`)
    }

    const from = self.$route.params[defaultFromKey]

    // 如果来自主资源详情、匹配到的嵌套资源无效，直接返回主资源detail
    if (from === 'detail') {
      self.matchedComponents = ['detail']
      return
    }

    if (matchedView.mode === MODE.EDIT_IN_TABLE) {
      self.matchedComponents = [from]
      return
    }

    if (['add', 'edit', 'list'].includes(from)) {
      self.matchedComponents = [from, matchedView.name]
      return
    }

    // 如果没有来自主资源信息、匹配到的嵌套资源无效，直接返回主资源list
    if (!from) {
      console.warn(`${matchedView.name} not validate while from is null`)
    }
    self.matchedComponents = ['list']
    return
  }

  if (matchedView.type === resourceType.PARALLEL) {
    if (matchedView.mode === MODE.EDIT_IN_DIALOG) {
      throw new Error('mode error: not support MODE:EDIT_IN_DIALOG for parallel resource')
    }
    self.matchedComponents = ['list', matchedView.name]
    return
  }
}

function generateDefaultResourceViewMap (type, name, mode) {
  if(type === resourceType.MAIN) {
    return {
      detail: {
        type: resourceType.MAIN,
        name: 'detail',
        mode: mode || MODE.EDIT_IN_DIALOG
      },
      edit: {
        type: resourceType.MAIN,
        name: 'edit',
        mode: mode || MODE.EDIT_IN_DIALOG
      },
      add: {
        type: resourceType.MAIN,
        name: 'add',
        mode: mode || MODE.EDIT_IN_DIALOG
      }
    }
  }

  if (type === resourceType.PARALLEL) {
    return {
      [`${name}`]: {
        type,
        name: `${name}`,
        mode
      },
      [`${name}Edit`]: {
        type,
        name: `${name}Edit`,
        mode
      },
      [`${name}Add`]: {
        type,
        name: `${name}Add`,
        mode
      },
      [`${name}Detail`]: {
        type,
        name: `${name}Detail`,
        mode
      }
    }
  }

  // 嵌套资源没有列表，列表放在主资源的添加或编辑页面
  return {
    [`${name}Edit`]: {
      type,
      name: `${name}Edit`,
      mode
    },
    [`${name}Add`]: {
      type,
      name: `${name}Add`,
      mode
    },
    [`${name}Detail`]: {
      type,
      name: `${name}Detail`,
      mode
    }
  }

}

function mergeRouteMap (type, viewMap, routeMap, name) {
  if (type === resourceType.MAIN) {
    routeMap.detail && (viewMap[routeMap.detail] = viewMap.detail)
    routeMap.edit && (viewMap[routeMap.edit] = viewMap.edit)
    routeMap.add && (viewMap[routeMap.add] = viewMap.add)
  } else {
    routeMap[name] && (viewMap[routeMap[name]] = viewMap[name])
    routeMap[`${name}Edit`] && (viewMap[routeMap[`${name}Edit`]] = viewMap[`${name}Edit`])
    routeMap[`${name}Add`] && (viewMap[routeMap[`${name}Add`]] = viewMap[`${name}Add`])
    routeMap[`${name}Detail`] && (viewMap[routeMap[`${name}Detail`]] = viewMap[`${name}Detail`])
  }
}



// WEBPACK FOOTER //
// ./packages/creator/common/mixins/matchedCompoents.js